var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"app"}},[_c('router-view',{key:_vm.$route.fullPath}),_c('Confirm'),_c('message-confirm')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }